import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useWallet } from '../../context/WalletContext';
import './Footer.css';

export default function Footer() {
  const location = useLocation();
  const { isConnected } = useWallet();
  // Hide the tall footer on mobile app pages where BottomNav is shown
  const isAppPage = location.pathname !== '/';
  const hideOnMobile = isConnected && isAppPage;

  return (
    <footer className={`footer ${hideOnMobile ? 'hide-mobile' : ''}`}>
      <div className="container footer-inner">
        <div className="footer-top">
          <div>
            <div className="footer-brand">
              <img src="/logos/xterra-icon.png" alt="X-Terra" />
              <span>X-TERRA MINING</span>
            </div>
            <p className="footer-tagline">
              Mine XT Tokens through the X-Terra Mining Platform and become part of a
              growing blockchain ecosystem focused on innovation and renewable energy.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-col">
              <div className="footer-col-title">Platform</div>
              <Link to="/dashboard">Dashboard</Link>
              <Link to="/invest">Purchase</Link>
              <Link to="/withdraw">Withdraw</Link>
              <Link to="/team">Team</Link>
            </div>
            <div className="footer-col">
              <div className="footer-col-title">Resources</div>
              <Link to="/#about">About</Link>
              <Link to="/#features">Features</Link>
              <Link to="/#security">Security</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} X-Terra Mining. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
